var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 15 15",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 2.5c0 .536-.337.993-.811 1.17l.954 2.544.448 1.195c.039.047.078.047.103.022l.902-.902 1.27-1.27a1.25 1.25 0 11.78.362l-.521 6.254c0 .69-.56 1.25-1.25 1.25h-6.25c-.69 0-1.25-.56-1.25-1.25l-.521-6.254a1.25 1.25 0 11.78-.362l1.27 1.27.902.902c.055.027.091.01.103-.022l.448-1.195.954-2.543A1.25 1.25 0 118.75 2.5zm-4.475 8.125L4.03 7.672l.643.643a1.313 1.313 0 002.157-.467L7.5 6.06l.67 1.788a1.312 1.312 0 002.158.467l.643-.643-.246 2.953h-6.45z",
    fill: "#fff"
  })));
};
export default SvgCrown;